import { personalInfo, socialLinks } from '../../../mocks/portfolio';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const navGroups = [
    {
      title: '导航',
      links: [
        { label: 'Home', id: 'home' },
        { label: 'About', id: 'about' },
        { label: 'Projects', id: 'projects' },
        { label: 'Blog', id: 'blog' },
        { label: 'Contact', id: 'contact' },
      ],
    },
    {
      title: '专业方向',
      links: [
        { label: 'AI 产品设计', id: 'projects' },
        { label: 'NLP 应用', id: 'projects' },
        { label: '推荐系统', id: 'projects' },
        { label: '数据产品', id: 'projects' },
        { label: '计算机视觉', id: 'projects' },
      ],
    },
  ];

  return (
    <footer id="footer" className="bg-gray-900 dark:bg-black text-white">
      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div>
                <div className="font-bold text-base">{personalInfo.name}</div>
                <div className="text-xs text-gray-400">{personalInfo.title}</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-sm mb-6">
              {personalInfo.tagline}
            </p>
            <div className="flex items-center gap-3">
              {socialLinks.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.name}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-700 text-gray-400 hover:border-orange-500 hover:text-orange-400 hover:-translate-y-1 transition-all cursor-pointer"
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Nav groups */}
          {navGroups.map((group) => (
            <div key={group.title}>
              <h5 className="text-xs uppercase tracking-widest text-gray-500 font-medium mb-4">{group.title}</h5>
              <ul className="flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <button
                      onClick={() => scrollTo(link.id)}
                      className="text-sm text-gray-400 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap text-left"
                    >
                      {link.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Contact info strip */}
        <div className="mt-12 pt-8 border-t border-gray-800 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {[
            { icon: 'ri-map-pin-line', label: 'Location', value: personalInfo.location },
            { icon: 'ri-mail-line', label: 'Email', value: personalInfo.email },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-gray-800 flex-shrink-0">
                <i className={`${item.icon} text-orange-400 text-sm`} />
              </div>
              <div>
                <div className="text-xs text-gray-500">{item.label}</div>
                <div className="text-sm text-gray-300">{item.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-500">
            &copy; {currentYear} {personalInfo.name} ({personalInfo.nameEn}). All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            {['Privacy Policy', 'Terms', 'Sitemap'].map((link) => (
              <a
                key={link}
                href="#footer"
                rel="nofollow"
                className="text-xs text-gray-500 hover:text-orange-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
